<template>
  <div class="brutto text-dark">
    <DModal :isBgOverlay="true" :showClose="false">
      <div class="brutto-container" slot="insertComponent">
        <div class="brutto-container__header">
          <h2>{{ $t('vue2.task_versions.save_task_overview_version') }}</h2>
          <div class="icon__bg-circle doc-modal__close" @click="close">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="brutto-container__body">
          <div class="brutto__users" v-if="theTab === 1">
            <div class="d-input-group">
              <h4 class="marg-05-bottom">{{ $t('vue2.task_versions.version_title') }}</h4>
              <input type="text" v-model="newVersionTitle" ref="version_name_input" @keyup.enter="theTab = 2">
              <p class="text-desc">{{ $t('vue2.task_versions.auto_name_description') }}</p>
            </div>
            <div class="save-versions__explained">
              <ul class="d-event__actions text-dark">
                <li class="d-event__actions__action" :class="{'d-event__actions__action--open': getTheFAQAcc(0)}">
                  <h4 @click="setTheFAQAcc(0)">
                    {{ $t('vue2.task_versions.what_is_version') }}
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                         stroke="currentColor" class="tw-icon w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5"/>
                    </svg>
                  </h4>
                  <transition name="accordion"
                              @enter="start"
                              @after-enter="end"
                              @before-leave="start"
                              @after-leave="end">
                    <div v-if="getTheFAQAcc(0)">
                      <p>{{ $t('vue2.task_versions.saved_task_overview_description') }}</p>
                    </div>
                  </transition>
                </li>
                <li class="d-event__actions__action" :class="{'d-event__actions__action--open': getTheFAQAcc(1)}">
                  <h4 @click="setTheFAQAcc(1)">
                    {{ $t('vue2.task_versions.find_saved_versions') }}
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                         stroke="currentColor" class="tw-icon w-6 h-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5"/>
                    </svg>
                  </h4>
                  <transition name="accordion"
                              @enter="start"
                              @after-enter="end"
                              @before-leave="start"
                              @after-leave="end">
                    <div v-if="getTheFAQAcc(1)">
                      <p>
                        {{ $t('vue2.task_versions.find_saved_versions_description') }}
                      </p>
                    </div>
                  </transition>
                </li>
              </ul>
            </div>
          </div>
          <div class="brutto__users" v-if="theTab === 2">
            <div class="brutto__users__header" v-if="tags.length > 0">
              <filterTags
                :users="usersSortedOnNameWithTags"
                :tags="tags"
                :selectedTags="appliedFilters"
                @set="setTagFromFilter"
                @remove="removeTagFromFilter">
              </filterTags>
            </div>
            <div class="brutto__users__list__header" @click="toggleAll"><span
              v-if="selectedUsers.length < 1">
              {{ $t('vue2.tagging.select_all') }}</span>
              <span v-else>{{ $t('vue2.tagging.unselect_all') }}</span>
            </div>
            <ul class="brutto__users__list">
              <li class="brutto__users__user"
                  v-for="user in filteredUsers"
                  @click="toggleUser(user)"
                  :class="{'is-selected': getIsUserSelected(user)}"
                  :key="user.id">
                {{ user.name }}
              </li>
            </ul>
          </div>
        </div>
        <div class="brutto-container__footer">
          <button @click="theTab = 1" v-if="theTab === 2">{{ $t('vue2.task_versions.go_back') }}</button>
          <button class="bttn bttn-primary" v-if="theTab === 1" @click="theTab = 2">
            {{ $t('vue2.task_versions.select_personnel') }}
          </button>
          <button class="bttn bttn-primary"
                  v-if="theTab === 2"
                  :class="[{'bttn-primary--disabled': selectedUsers.length < 1}, {'bttn--loading': isSaving}]"
                  @click="save"
                  :content="$t('vue2.task_versions.select_min_user')"
                  v-tippy="{
                    arrow: true,
                    onShow: () => selectedUsers.length < 1
                  }"
          >{{ $t('vue2.task_versions.save_for_selected_users') }} {{ selectedUsers.length }} {{ $t('vue2.task_versions.save_for_selected_users_of') }} {{ filteredUsers.length }}
          </button>
        </div>
      </div>
    </DModal>
  </div>
</template>

<script>
import filterTags from '../Tagging/TaggingFilter'
import DModal from '../common/DModal'
import {mapGetters} from 'vuex'
import eventbus from '../../eventbus'
import AppToggle from '../common/AppToggle'
import docendo from '../../docendo'

export default {
  components: {AppToggle, DModal, filterTags},
  data () {
    return {
      isSaving: false,
      selectedUsers: [],
      appliedFilters: [],
      tags: [],
      isLoadingTags: false,
      newVersionTitle: '',
      theTab: 1,
      theFAQAcc: null
    }
  },
  computed: {
    ...mapGetters([
      'usersSortedOnName'
    ]),
    schoolId () {
      return this.$route && this.$route.params.school_id ? this.$route.params.school_id : this.$store.getters.schoolId ? this.$store.getters.schoolId : window.SCHOOL.id
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    usersSortedOnNameWithTags () {
      return this.usersSortedOnName.map(user => {
        user.tags = user.user_tags
        return user
      })
    },
    filteredUsers () {
      let passedUsers = this.usersSortedOnName
      for (let i = 0; i < this.appliedFilters.length; i++) {
        passedUsers = passedUsers.filter(user => {
          return user.user_tags && user.user_tags.indexOf(this.appliedFilters[i]) > -1
        })
      }
      return passedUsers
    }
  },
  methods: {
    start (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    end (el) {
      el.style.height = ''
    },
    setTheFAQAcc (num) {
      if (this.theFAQAcc === num) {
        this.theFAQAcc = null
      } else {
        this.theFAQAcc = num
      }
    },
    getTheFAQAcc (num) {
      return this.theFAQAcc === num
    },
    toggleAll () {
      if (this.selectedUsers.length > 0) {
        this.selectedUsers = []
      } else {
        this.selectedUsers = []
        this.filteredUsers.forEach(user => this.selectedUsers.push(user.id))
      }
    },
    getIsUserSelected (user) {
      const idx = this.selectedUsers.findIndex(selectedUser => selectedUser === user.id)
      return idx > -1
    },
    toggleUser (user) {
      const idx = this.selectedUsers.findIndex(selectedUser => selectedUser === user.id)
      if (idx > -1) {
        this.selectedUsers.splice(idx, 1)
      } else {
        this.selectedUsers.push(user.id)
      }
    },
    setTagFromFilter (tag) {
      this.selectedUsers = []
      this.appliedFilters.push(tag)
    },
    removeTagFromFilter (tag) {
      this.selectedUsers = []
      this.appliedFilters.splice(this.appliedFilters.indexOf(tag), 1)
    },
    readTags () {
      this.isLoadingTags = true
      docendo.schoolTags(this.schoolId, data => {
        this.tags = data
        this.isLoadingTags = false
      })
    },
    close () {
      this.reset()
      this.$emit('close')
    },
    save () {
      if (this.selectedUsers.length < 1) {
        return
      }
      this.isSaving = true
      docendo.bulkCreateTaskOverview(this.schoolId, this.activeSchoolYear.id, this.selectedUsers, this.newVersionTitle,
        success => {
          this.isSaving = false
          eventbus.toast = {text: 'Gemt', 'success': true}
          this.close()
        }, failure => {
          eventbus.toast = {text: 'Noget gik galt', 'success': false}
        })
    },
    reset () {
      this.isSaving = false
      this.selectedUsers = []
      this.newVersionTitle = ''
      this.theTab = 1
    }
  },
  mounted () {
    this.readTags()
    this.$nextTick(_ => {
      this.$refs.version_name_input.focus()
    })
  }
}
</script>

<style>
@import '../../assets/css/variables.css';

.brutto {
  position: relative;
}

.brutto input[type="number"] {
  background: #ffffff;
}

.brutto-container {
  background: #fff;
  border-radius: 4px;
}

.brutto-container__header {
  padding: 1rem;
  border-bottom: 1px solid #dddddd;
}

.brutto-container__body {
  display: flex;
  background: var(--bg-grey);
  min-height: 65vh;
  max-height: calc(100vh - (52px + 53px));
  overflow-y: auto;
  overscroll-behavior: contain;
  min-width: 500px;
}

.brutto-container__body__left {
  width: 500px;
  border-right: 1px solid #dddddd;
  padding: 1rem;
}

.brutto__items {
  margin: 0;
  padding: 1rem;
  font-weight: normal;
}

.brutto__users {
  width: 500px;
}

.brutto__items__item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.brutto__items__item.brutto__items__item--netto-hours {
  margin-bottom: 0;
}


.norm-title, .norm-title + label {
  user-select: none;
}

.brutto__items__item > input[type="text"], .brutto__items__item > input[type="number"], .brutto__items__item > input[type="range"] {
  width: 150px;
  font-weight: normal;
  padding: 0;
}

.brutto__items__item input[type="number"]:not([disabled]) {
  background: #ffffff;
}

.brutto__items__item .d-input-group {
  display: flex;
  align-items: center;
}

.brutto__items__item .d-input-group label {
  margin-right: 2px;
}

.brutto-container__footer {
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #dddddd;
}

.brutto-container__footer > .bttn:last-child {
  margin-left: 1rem;
}

.brutto__users__header {
  border-bottom: 1px solid #dddddd;
  padding: 1rem;
}

.brutto__users__user {
  position: relative;
  display: flex;
  align-items: center;
  padding: 1rem;
  cursor: pointer;
  transition: background-color 0.15s, transform 0.25s;
}

.brutto__users__user:hover {
  background-color: aliceblue;
}

.brutto__users__user:active {
  transform: scale(0.98);
}

.brutto__users__user:before {
  content: '';
  font-family: 'icomoon' !important;
  color: #ffffff;
  display: flex;
  font-size: 9px;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  margin-right: 0.5rem;
  cursor: pointer;
  transition: background-color 0.15s;
}

.brutto__users__user.is-selected:before {
  content: '\ED72';
  background-color: var(--blue);
  border-color: var(--blue);
}

.brutto__users__list {
  max-height: 65vh;
  overflow: auto;
}

.d-input-group__input {
  display: flex;
  align-items: center;
  font-weight: normal;
}

.d-input-group__input span {
  margin-right: 5px;
  font-size: 0.85rem;
}

.brutto__items__item__netto {
  margin-top: 2rem;
}

.brutto__users__list__header {
  cursor: pointer;
  padding: 0.25rem 1rem;
  font-weight: normal;
  font-size: 0.9rem;
  user-select: none;
  transition: transform 0.25s;
}

.brutto__users__list__header:hover {
  color: var(--blue);
}

.brutto__users__list__header:active {
  transform: scale(0.98);
}

.bttn-primary.bttn-primary--disabled {
  opacity: 0.65;
  cursor: not-allowed;
  box-shadow: none !important;
}

.bttn.bttn-primary.bttn--loading:before {
  border: 3px solid #ffffff;
  border-left: 3px solid transparent;
  pointer-events: none;
}

.user-agreements__notefield {
  font-weight: normal;
  border-top: 1px solid #ddd;
  padding: 1rem 0 2rem 0;
  margin-top: 2rem;
}

.user-agreements__notefield__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1rem 0;
}

.user-agreements__notefield__header label.d-label {
  margin-left: 0.5rem;
  line-height: 1;
}

.tw-icon {
  width: 16px;
}

.tw-icon .secondary {
  fill: #0D2B3E;
}

.tw-icon .primary {
  fill: #A5B3BB;
}

h4.text-explainer {
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: normal;
  margin-top: 0.5rem;
}

h4.text-explainer svg {
  margin-right: 5px;
}

.text-explainer {
  font-weight: normal;
}

.brutto-warning {
  width: 350px;
  border-radius: 4px;
}

.brutto-warning__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  padding: 1rem;
  border-bottom: 1px solid #dddddd;
  border-radius: 4px 4px 0 0;
}

.brutto-warning__body {
  padding: 1rem;
}

.brutto-warning__footer {
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
  border-radius: 0 0 4px 4px;
}

.brutto-warning__footer button {
  margin-left: 1rem;
}

.bttn.bttn-primary.bttn-primary--small {
  padding: 2px 1rem;
}

.tw-icon.tw-icon--red {
  color: #ef4746;
}

.d-tabs {
  display: flex;
}

.d-tabs__tab {
  border: 1px solid transparent;
  border-bottom: 0;
  padding: 0.5rem;
  border-radius: 4px 4px 0 0;
  margin-right: 0.5rem;
  margin-bottom: -1px;
  cursor: pointer;
}

.d-tabs__tab.d-tabs__tab--active {
  border-color: #dddddd;
  background: #edf0f5;
}

.d-tabs__content {
  border: 1px solid #dddddd;
  padding: 1rem;
  border-radius: 0 4px 4px 4px;
}

.norm-title {
  font-weight: bold;
}

.label-with-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  border-radius: 4px;
  margin: 0 -0.5rem;
  cursor: pointer;
  transition: 0.15s ease;
}

.label-with-toggle label {
  cursor: pointer;
}

.label-with-toggle:hover {
  background: aliceblue;
}

.brutto__items__item__container {
  border: 1px solid #dddddd;
  padding: 0.5rem 1rem;
  margin: 0 -1rem 1rem -1rem;
  border-radius: 4px;
}

.brutto__items__item__container .brutto__items__item {
  margin-top: 0.5rem;
}

.brutto__items__item__container__notefield {
  margin: -1rem 0;
}

.brutto--kindergarten .brutto__items__item__container__notefield {
  margin: 1rem 0;
}

.brutto__users__user:hover .d-edit-btn {
  opacity: 1;
}

.d-edit-btn {
  opacity: 0;
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
}

.text-desc {
  font-size: 12px;
  color: #a2a3a6;
  font-weight: normal;
  font-style: italic;
}

.save-versions__explained {
  font-weight: normal;
}


.d-event__actions {
  flex: 1;
  margin: 3rem 1rem 0 1rem;
}

.d-event__actions__action {
  position: relative;
  width: 100%;
  border: 1px solid #d9d9d9;
  border-bottom: 0;
}

.d-event__actions__action div {
  overflow: hidden;
}

.d-event__actions__action:nth-child(2),
.d-event__actions__action:nth-child(2) h4 {
  border-radius: 4px 4px 0 0;
}

.d-event__actions__action:nth-child(2) {
  border-top: 1px solid #d9d9d9;
}

.d-event__actions__action:last-child {
  border-radius: 0 0 4px 4px;
  border-bottom: 1px solid #d9d9d9;
}

.d-event__actions__action h4 {
  position: relative;
  cursor: pointer;
  padding: 1rem;
  border-bottom: 1px solid #d9d9d9;
}

.d-event__actions__action h4:hover {
  background: aliceblue;
}

.d-event__actions__action h4 > svg {
  position: absolute;
  top: 1.15rem;
  right: 1rem;
  z-index: 2;
  transition: transform 0.5s;
}

.d-event__actions__action.d-event__actions__action--open h4 > svg {
  transform: rotate(-180deg);
}

.d-event__actions__action div > * {
  margin: 1rem;
}

.d-event__actions__action button,
.d-event__actions__action select {
  width: calc(100% - 2rem);
  height: auto;
  min-height: 28px;
}

.d-event__actions__action select {
  border-radius: 4px;
}

.accordion-enter-active,
.accordion-leave-active {
  will-change: height, opacity;
  transition: height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// SaveTaskOverview.vue?3df1093f